type PhoneNumberProps = {
  number: string;
};

const PhoneNumber = ({ number }: PhoneNumberProps) => {
  return <a href={`tel:${number}`}>{number}</a>;
};

export default PhoneNumber;
